import { gql } from '@apollo/client';

export const ALL_CIRCUITS = gql`
  query getCircuits($input: NameSearchArgs!) {
    circuits: getCircuits(input: $input) {
      id
      name
    }
  }
`;
